import React, { lazy } from 'react';
import { Star } from 'lucide-react';
const TESTIMONIALS = [{
  name: 'María José R.',
  country: 'México',
  quote: 'Llevaba años sintiendo un nudo en el pecho que no me dejaba dormir. Este kit me dio exactamente lo que necesitaba: pasos claros. Dedicar 15 minutos al día se ha vuelto mi momento sagrado. Por fin siento paz.',
  photo: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?auto=format&fit=crop&w=200&h=200&q=80'
}, {
  name: 'Lucía F.',
  country: 'Colombia',
  quote: 'Siempre intentaba entender por qué me sentía tan agotada, pero solo daba vueltas en mi cabeza. El Workbook me ayudó a soltar cosas que ni sabía que cargaba. Es la mejor inversión que he hecho en mí.',
  photo: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?auto=format&fit=crop&w=200&h=200&q=80'
}, {
  name: 'Andrea M.',
  country: 'Argentina',
  quote: 'Las cartas terapéuticas son mi salvavidas en los días difíciles. Cuando la ansiedad ataca, saco una carta y me ayuda a volver a mi centro. Es un sistema hermoso y muy fácil de seguir.',
  photo: 'https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?auto=format&fit=crop&w=200&h=200&q=80'
}, {
  name: 'Paola G.',
  country: 'Perú',
  quote: 'No es un curso más que dejas a medias. Es súper práctico. El diario de 30 días me ha ayudado a crear un hábito real. Siento que he recuperado el control de mi vida y mis emociones.',
  photo: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?auto=format&fit=crop&w=200&h=200&q=80'
}, {
  name: 'Daniela S.',
  country: 'España',
  quote: 'Pensé que nunca iba a superar mi pasado. Este método me enseñó a no luchar contra mis emociones, sino a darles su lugar. Me siento más ligera, más tranquila y sobre todo, más yo misma.',
  photo: 'https://images.unsplash.com/photo-1552699611-e2c208d5d9cf?auto=format&fit=crop&w=200&h=200&q=80'
}];
export function Testimonials() {
  return <div className="py-12" data-id="element-273">
      <h2 className="text-3xl md:text-4xl font-serif font-bold text-center text-[#5d4a6e] mb-10" data-id="element-274">
        Lo que dicen otras mujeres...
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto" data-id="element-275">
        {TESTIMONIALS.map((t, i) => <div key={i} className={`bg-white p-6 rounded-2xl shadow-sm border border-[#f0e6d2] ${i === TESTIMONIALS.length - 1 ? 'md:col-span-2 md:max-w-xl md:mx-auto' : ''}`} data-id="element-276">
            <div className="flex items-center gap-4 mb-4" data-id="element-277">
              <img src={t.photo} alt={`Foto de ${t.name}`} loading="lazy" className="w-14 h-14 rounded-full object-cover border-2 border-[#f0e6d2] shrink-0" data-id="element-278" />
              <div data-id="element-279">
                <h4 className="font-bold text-gray-800" data-id="element-280">{t.name}</h4>
                <p className="text-sm text-gray-500" data-id="element-281">{t.country}</p>
              </div>
            </div>
            <div className="flex gap-1 mb-3 text-[#c9a24b]" data-id="element-282">
              {[...Array(5)].map((_, j) => <Star key={j} size={16} fill="currentColor" data-id="element-283" />)}
            </div>
            <p className="text-gray-700 italic" data-id="element-284">"{t.quote}"</p>
          </div>)}
      </div>
    </div>;
}